<div *ngIf="lighthouseData">
  <div
    *ngFor="let pageReport of lighthouseData; let i = index; trackBy: trackByIndex"
    class="lighthouse-detail p-2 mb-5"

  >
    <div
      *ngIf="!pageReport.error"
    >
      <div class="font-bold text-lg mb-2">
        {{ getPageUrlFromReport(pageReport) }}
      </div>
      <div class="flex mb-10 gap-8">

        <div *ngIf="pageReport.desktop" class="w-7/12">
          <div class="text-lg font-medium border-gray-300 border-b-2 mb-5">
            Desktop
          </div>
          <div *ngIf="pageReport.desktop.FinalScreenshot">
            <img src="{{getReportScreenshotUrlFromPath(pageReport.desktop.FinalScreenshot, 'desktop')}}"
                 alt="Desktop Screenshot"
                 class="float-left max-w-72 mr-4"
            >
          </div>
          <div>
            <div *ngIf="pageReport.desktop['Server Response Time']">
              <app-performance-check
                label="TTFB"
                [value]="convertServerResponseTimeToString(pageReport.desktop['Server Response Time'].numericValue)"
                [style]="getTTFBStyling(pageReport.desktop['Server Response Time'].numericValue)"></app-performance-check>
            </div>
            <div *ngIf="pageReport.desktop['CLS']">
              <app-performance-check
                label="CLS"
                [value]="pageReport.desktop['CLS'].displayValue"
                [style]="getCLSStyling(pageReport.desktop['CLS'].numericValue)"
              ></app-performance-check>
            </div>
            <div *ngIf="pageReport.desktop['LCP']">
              <app-performance-check
                label="LCP"
                [value]="pageReport.desktop['LCP'].displayValue"
                [style]="getLCPStyling(pageReport.desktop['LCP'].numericValue)"
              ></app-performance-check>
            </div>
          </div>
          <div class="clear-both">
            <a href="{{getReportUrlFromPath(pageReport.desktop.ReportPath, 'desktop')}}" target="_blank" rel="noopener"
               title="Link to Page"
               class="bg-black text-white font-bold py-2 px-4 rounded inline-block mt-4"
            >
              View Report
            </a>
          </div>
        </div>
        <div *ngIf="pageReport.mobile" class="w-5/12">
          <div class="text-lg font-medium border-gray-300 border-b mb-5 clear-both ">
            Mobile
            <a href="{{getReportUrlFromPath(pageReport.mobile.ReportPath, 'mobile')}}" target="_blank" rel="noopener"
               title="Link to Page" [style]="{'display':'inline-block','marginLeft': '10px', 'fontSize': '12px'}">
              <i class="pi pi-external-link" [style]="{'fontSize': '12px'}"></i>
            </a>
          </div>
          <div *ngIf="pageReport.mobile.FinalScreenshot">
            <img src="{{getReportScreenshotUrlFromPath(pageReport.mobile.FinalScreenshot, 'mobile')}}"
                 alt="Mobile Screenshot"
                 class="float-left max-w-36 mr-5"
            >
          </div>
          <div>
            <div *ngIf="pageReport.mobile['Server Response Time']">
              <app-performance-check
                label="TTFB"
                [value]="convertServerResponseTimeToString(pageReport.mobile['Server Response Time'].numericValue)"
                [style]="getTTFBStyling(pageReport.mobile['Server Response Time'].numericValue)"
              ></app-performance-check>
            </div>
            <div *ngIf="pageReport.mobile['CLS']">
              <app-performance-check
                label="CLS"
                [value]="pageReport.mobile['CLS'].displayValue"
                [style]="getCLSStyling(pageReport.mobile['CLS'].numericValue)"
              ></app-performance-check>
            </div>
            <div *ngIf="pageReport.mobile['LCP']">
              <app-performance-check
                label="LCP"
                [value]="pageReport.mobile['LCP'].displayValue"
                [style]="getLCPStyling(pageReport.mobile['LCP'].numericValue)"
              ></app-performance-check>

            </div>
          </div>
          <div class="clear-both">
            <a href="{{getReportUrlFromPath(pageReport.desktop.ReportPath, 'mobile')}}" target="_blank" rel="noopener"
               title="Link to Page"
               class="bg-black text-white font-bold py-2 px-4 rounded inline-block mt-4"
            >
              View Report
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
